export enum TEnumPlacaBara  {
    placa = 'placa',
    bara = 'bara',
    others = 'others'
}
